import { useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./HelpModal.module.css";


export default function HelpModal() {
    const dispatch = useDispatch();

    const handleClose = function() {
        dispatch(uiActions.setHelpModalActive(false));
    } 

    return (
        <>
        <PopUpModal handleClose={handleClose}>
            <div className={styles.contentMain}>
            <h2>Help</h2>
            <div className={styles.content}>
                  <div className={styles.wrapIt}>
                        <h4>Get Started</h4>
                        <div className={styles.wBar}></div>
                        <p>Filter floorplans with dropdown buttons: Square Ft., Beds, Baths, Communities and  House Type.</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Select Floor Plan</h4>
                        <div className={styles.wBar}></div>
                        <p>Select a desired floor plan and then floor plan scene to begin visualizing.</p>
                    </div>
                    <div className={styles.wrapIt}>
                        <h4>Product Menus</h4>
                        <div className={styles.wBar}></div>
                        <p>Select a product to apply to your selected floor plan scene.</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Steps</h4>
                        <div className={styles.wBar}></div>
                        <p>Cycle through the product menus using the Step Selector's Previous and Next buttons</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Switch To</h4>
                        <div className={styles.wBar}></div>
                        <p>Switch scenes by clicking on a Switch To button.</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Save Project</h4>
                        <div className={styles.wBar}></div>
                        <p>Click Save or My Projects to save your project.</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Extras</h4>
                        <div className={styles.wBar}></div>
                        <p>Extra features include:Share and Print.  </p>
                    </div>
                </div>
            </div>
        </PopUpModal>
        </>
    );
}
